<template>
  <div class="fila-atendimento">
    <div class="d-flex align-center justify-center py-8 bg-default">
      <v-container>
        <div class="text-center">
          <h4 class="secondary-font">Sala de atendimento</h4>
          <h5 class="secondary-font text--secondary mt-2">
            Atenção, no momento você está em atendimento
          </h5>
        </div>
      </v-container>
    </div>
    <div class="pa-3">
      <div class="mb-3 ml-auto">
        <v-btn dense color="error" outlined @click="deixarSala">
          <v-icon size="18" left>mdi-exit-to-app</v-icon>
          Deixar a sala
        </v-btn>
      </div>
      <div class="whereby">
        <whereby-embed
          v-if="roomUrl"
          class="whereby-embed"
          audio="on"
          video="on"
          :room="roomUrl"
        ></whereby-embed>
      </div>
    </div>
  </div>
</template>

<script>
const ROOM_URL =
  'https://limer-saude.whereby.com/sala-saude-mental6567486a-d8eb-47cf-851a-2ead8e527337'

export default {
  name: 'SaudeMentalSalaAtendimento',
  data() {
    return {
      roomUrl: null
    }
  },
  mounted() {
    const meetingRoomUrl = new URL(ROOM_URL)
    const urlParams = new URLSearchParams(meetingRoomUrl.search)
    urlParams.set('displayName', 'Paciente 1')
    urlParams.set('lang', 'pt')
    urlParams.set('leaveButton', 'off')
    urlParams.set('topToolbar', 'off')
    urlParams.set('precallReview', 'off')
    urlParams.set('screenshare', 'off')
    meetingRoomUrl.search = urlParams.toString()
    this.roomUrl = meetingRoomUrl.href
  },
  methods: {
    deixarSala() {
      this.roomUrl = null
      this.$router.push({ name: 'dashboard' })
    }
  }
}
</script>

<style scoped>
.whereby {
  overflow-y: hidden;
}

.whereby-embed {
  height: 70vh !important;
  margin-top: -35px;
}
</style>
